import { useEffect } from 'react'
import React from 'react'
import { getShopStats } from '@/requests/analytics'
import { useShop } from '@/context/shop-context'
import { useQuery } from '@tanstack/react-query'
import { AnalyticsCard } from './analytic-card'
import { useTranslation } from '@/hooks/use-translation'
import dayjs from "dayjs";

interface Stat {
  value: number;
  prev: number;
}

interface WebsiteStats {
  pageviews: Stat;
  visitors: Stat;
  visits: Stat;
  bounces: Stat;
  totaltime: Stat;
}

export const DashboardAnalyticsCards = () => {
  const [analytics, setAnalytics] = React.useState<WebsiteStats | null>(null);
  const { activeShop } = useShop()
  const { t } = useTranslation()

  const { data, isLoading } = useQuery({
    queryKey: ['analytics.shop.stats', activeShop?._id],
    queryFn: () => getShopStats(activeShop?._id || '', dayjs().startOf("day").valueOf(), dayjs().endOf("day").valueOf()),
    enabled: !!activeShop?._id,
  })

  useEffect(() => {
    if (data) {
      setAnalytics(data)
    } else {
      setAnalytics(null)
    }
  }, [data])

  return (
    <>
      <AnalyticsCard
        title={t('Page Views')}
        value={analytics?.pageviews?.value ?? 0}
        prev={analytics?.pageviews?.prev ?? 0}
        isLoading={isLoading}
        tooltip={t('Total views your pages received today.')}
      />
      <AnalyticsCard
        title={t('Visitors')}
        value={analytics?.visitors?.value ?? 0}
        prev={analytics?.visitors?.prev ?? 0}
        isLoading={isLoading}
        tooltip={t('Unique visitors who accessed your site today.')}
      />
      <AnalyticsCard
        title={t('Time on Site')}
        value={analytics?.totaltime?.value ?? 0}
        prev={analytics?.totaltime?.prev ?? 0}
        isLoading={isLoading}
        tooltip={t('Average time users spent on your site today.')}
      />
      <AnalyticsCard
        title={t('Bounces')}
        value={analytics?.bounces?.value ?? 0}
        prev={analytics?.bounces?.prev ?? 0}
        isLoading={isLoading}
        tooltip={t('Sessions with only one page view.')}
      />
    </>
  )
}